export default class classVeryProfileImg {
  static getPropsTemplate = () => ({
    CSS: [""],
    src: "",
    sizeImg: 0,
    sizeIcon: 0,
  });
}
